import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlaneSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.1615 0.757373C16.4219 0.627165 16.7149 0.627165 16.9753 0.822477C17.2357 1.01779 17.3659 1.24565 17.3334 1.57118L14.9896 15.6337C14.9245 15.8941 14.7943 16.0569 14.5665 16.1871C14.3386 16.3173 14.1107 16.3498 13.9154 16.2196L9.8464 14.5269L7.79562 17.0334C7.63286 17.2287 7.43755 17.3264 7.20968 17.3264C6.98182 17.3264 6.78651 17.2613 6.62375 17.1311C6.46099 17.0009 6.39588 16.773 6.39588 16.5126V13.9084L14.2409 4.3381C14.306 4.273 14.2735 4.17534 14.2084 4.11024C14.1107 4.04513 14.0131 4.01258 13.948 4.07769L4.60552 12.3134L1.155 10.8811C0.829476 10.7509 0.666716 10.523 0.666716 10.1975C0.634164 9.87196 0.764372 9.64409 1.08989 9.48133L16.1615 0.757373Z",
		fill: "currentColor"
	})
});
export default SvgPaperPlaneSolid;
